import spinners from '@components/loader/spinners'
import swal from 'sweetalert'

import('./list.css')

export default function List(opts){
    let container = opts.container
    BaseConstructor.call(this)
    let context = this

    this.generate = parameters =>{
        console.log(parameters)
        $(container).html('') //limpando em caso de reload
        parameters.forEach(parameter=>{
            let listItem = new ListItem({parameter:parameter})
            $(container).append(listItem.getElement())

            listItem.on('button_edit_click', parameter=>{
                context.trigger('edit_parameter', parameter)
            })

            listItem.on('button_use_view', parameter=>{
                context.trigger('use_view', parameter)
            })
            listItem.on('button_destroy_view', parameter_id=>{
                console.log('sim');
                context.trigger('destroy_view', parameter_id)
            })
        })
    }

    this.loading = _ =>{
        $(container).html(`<div class='flex flex-v flex-gap flex-h-center flex-v-center' style='width:100%;height:200px'>${spinners.defaultSpinner(1, '','md')}<div class='font-weight-bold' style='font-size:larger'>Carregando views</div></div>`)
    }
}

List.prototype = Object.create(BaseConstructor.prototype)

function ListItem(opts){
    BaseConstructor.call(this)
    let parameter = opts.parameter
    let elements = {}
    let context = this

    this.getElement = _ =>{
        return elements.container
    }

    init()

    function init(){
        elements.container = context.createElement('div', 'views-list-listitem-wrapper')
        let html = `<div>${parameter.values.view_name}</div><div><span class='badge badge-success'>${Object.values(parameter.values.charts).length} gráficos</span></div>`
        $(elements.container).html(html)
        $(elements.container).append(generateControls)
    }

    function generateControls(){
        let container = context.createElement('div', 'flex flex-gap')
        let el = context.createElement('button', 'view-list-listitem-button edit', '<i class="fas fa-cog"></i>')
        let el_use = context.createElement('button', 'view-list-listitem-button use', '<i class="fas fa-play-circle"></i>')
        let el_destroy = context.createElement('button', 'view-list-listitem-button destroy', '<i class="fas fa-trash"></i>')

        el_use.title = "Carregar view"
        el.title = "Configurar view"
        el_destroy.title = "Excluir view"


        $(container).append(el_use, el, el_destroy)
        $(el).on('click', () =>{
            context.trigger('button_edit_click', parameter)
        })
        $(el_use).on('click', () =>{
            context.trigger('button_use_view', parameter)
        })
        $(el_destroy).on('click', () =>{
            let el = context.createElement('div', '', "<b>CUIDADO</b>, essa ação <b>NÃO</b> poderá ser desfeita!")
            swal({
                title: `Excluir view '${parameter.values.view_name}'?`,
                content: el,
                icon: "warning",
                buttons: true
            }).then(value=>{
                if(value){
                    console.log(value);
                    context.trigger('button_destroy_view', parameter.id)
                }
            })
        })

        return container
    }
}

ListItem.prototype = Object.create(BaseConstructor.prototype)